/**
 * Standardized pagination response format for all paginated API endpoints.
 * This interface matches the backend PaginatedResponse structure.
 */
export interface PaginatedResponse<T> {
  /** Array of items for the current page */
  data: T[];
  /** Total number of items across all pages */
  total: number;
  /** Current page number (1-indexed) */
  page: number;
  /** Number of items per page */
  limit: number;
}

/**
 * Pagination parameters for API requests
 */
export interface PaginationParams {
  /** Page number (1-indexed, default: 1) */
  page?: number;
  /** Number of items per page (default: 50, max: 100) */
  limit?: number;
}

/**
 * Default pagination values matching backend defaults
 */
export const PAGINATION_DEFAULTS = {
  page: 1,
  limit: 50,
  maxLimit: 100,
  minLimit: 1,
  minPage: 1,
} as const;
